
export const validateValue = (value) => {
  if (value && typeof value == 'string') {
    if (value !== undefined || value !== 'undefined' || value !== null) {
      return true
    }
  } else {
    return false
  }
}